import * as React from "react";
const SvgFiRrMistletoe = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-mistletoe_svg__a)">
      <path
        fill="#062147"
        d="M16.632 10.652A4.01 4.01 0 0 0 19 7c0-2.206-1.794-4-4-4a4 4 0 0 0-3.262 1.688C10.224 2.05 7.089 0 1 0a1 1 0 0 0 0 2c3.833 0 6.217.835 7.689 2.06A4.004 4.004 0 0 0 4 8c0 1.445.771 2.714 1.923 3.417C2.967 13.135 0 15.884 0 20c0 2.206 1.794 4 4 4s4-1.794 4-4c0-4.918 2.787-7.751 3.997-8.75 1.2 1 4.003 3.86 4.003 8.75 0 2.206 1.794 4 4 4s4-1.794 4-4c0-4.794-4.024-7.733-7.368-9.348M15 5c1.103 0 2 .897 2 2s-.897 2-2 2-2-.897-2-2 .897-2 2-2M8 6c1.103 0 2 .897 2 2s-.897 2-2 2-2-.897-2-2 .897-2 2-2M6 20c0 1.103-.897 2-2 2s-2-.897-2-2c0-3.727 3.377-6.151 6.252-7.54C7.063 14.227 6 16.723 6 20m14 2c-1.103 0-2-.897-2-2 0-3.277-1.063-5.773-2.252-7.54C18.623 13.849 22 16.273 22 20c0 1.103-.897 2-2 2"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-mistletoe_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrMistletoe;
